module.exports = __webpack_public_path__ + "img/xianduan.d1d4767c.svg";